import React, { useEffect, useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";
import { AppContext } from "../../context/app-context";
import DietHeader from './DietHeader';
import diet360Img from './images/diet360.svg';
import differImg from './images/differ.png';
import API from "../../helper/API";
import DietPlanCard from "./component/DietPlanCard";
import HowThisWorks from "./component/HowThisWorks";
import Skeleton from "react-loading-skeleton";
import { checkMyDietPlan, sendFirebaseEvent } from '../../helper/mobile';

const PARAMS = ['userId', 'groupId', 'appVersion', 'osType', 'token', 'isGoalSet', 'urlType'];

const Diet = () => {

  let navigate = useNavigate();
  const [state, dispatch] = useContext(AppContext);
  const [currentDietPlan, setCurrentDietPlan] = useState();
  const [dietLoading, setDietLoading] = useState(true);
  
  const userObj = PARAMS.reduce((acc,curr)=> (acc[curr]=new URLSearchParams(window.location.search).get(curr),acc),{});
  let urlType = userObj.urlType;
  if(userObj?.token) {
    localStorage.setItem('token', userObj.token);
  }

  useEffect(() => {
    dispatch({
      type: "USER_DETAILS",
      payload: userObj
    });

    if(userObj.userId) {
      API.get(`/user/dietplan/?userId=${userObj.userId}`).then(response => {
        if(response?.data?.dietPlanType) {
          const dp = state.dietPlans.find(obj => obj.dietPlanType === response.data.dietPlanType);
          dp.dietPlanId = response.data.dietPlanId;
          dp.paymentStatus = response.data.paymentStatus;
          dp.planStartDate = response.data.planStartDate;
          dp.planEndDate = response.data.planEndDate;
          dp.assessmentCompleted = response.data?.assessmentCompleted;
          setCurrentDietPlan(dp);
        }
        setDietLoading(false);
      }).catch(error => {
        console.log("Error", error);
        if(urlType === 'freeDietPlan') {
          navigate('one_month_smart_diet_plan');
        }
        setDietLoading(false);
      })
    }else {
      setDietLoading(false);
    }
  }, []);

  const handleOnClick = () => {
    sendFirebaseEvent('diet_plan_view_click', 'click_event', 'diet_plan_status');
    console.log("Please kill the web view - check my diet plan!");
    checkMyDietPlan();
  }

  const assessmentBtnClick = (cdp) => {
    navigate(`/diet/${cdp.dietPlanType}/${cdp.dietPlanId}/assessment/${state.user.isGoalSet === 'true' ? 'planType' : 'healthConditions'}`);
  }

  return (
    <div className={currentDietPlan ? '' : dietLoading ? '' : "diet-wrapper pb-4" } >
      { dietLoading ? <Skeleton height={140} className="mb-3" /> : <DietHeader dietPlan={currentDietPlan} planType={urlType === 'freeDietPlan' ? 'one_month_smart_diet_plan' : null} /> }
      { currentDietPlan ? 
        <Container className="diet-container">
          <DietPlanCard dietPlan={currentDietPlan}  />
          <HowThisWorks dietPlan={currentDietPlan} />
          {
            currentDietPlan.dietPlanType === 'one_month_smart_diet_plan' && 
            <div className="floating-btn-div">
              {currentDietPlan.assessmentCompleted ? <Button className='diet-payment-btn' onClick={() => handleOnClick()}>View my diet plan</Button> :
                <Button className='diet-payment-btn' onClick={() => assessmentBtnClick(currentDietPlan)}>Complete your assessment</Button>
              }
              
            </div>
          }
        </Container> :
        <Container className="diet-container">
        <div className="text-center">
        { dietLoading ? <Skeleton height={80} width="80%" /> : <img src={diet360Img} /> }
          <p className="diet-green-text mt-4 mb-0 pb-3">
            { dietLoading ? <Skeleton count={4} /> :
            'Our premium Diet 360 nutrition plans, combine behavioural psychology, technology, and live nutritionists coaching, helping our users in their weight management journey.'}
          </p>
        </div>
       <h4 className="mt-3 mb-4 diet-section-title">{dietLoading ? <Skeleton height={30} width="60%" /> : 'How our premium plans differ?' }</h4>
        { dietLoading ?
          <Row className="mb-4">
            <Col className="text-center">
              <Skeleton
                circle
                height={50}
                width={50}
                containerClassName="avatar-skeleton"
              />
              <Skeleton width={70} />
            </Col>
            <Col className="text-center">
              <Skeleton
                circle
                height={50}
                width={50}
                containerClassName="avatar-skeleton"
              />
              <Skeleton width={70} />
            </Col>
            <Col className="text-center">
              <Skeleton
                circle
                height={50}
                width={50}
                containerClassName="avatar-skeleton"
              />
              <Skeleton width={70} />
            </Col>
            <Col className="text-center">
              <Skeleton
                circle
                height={50}
                width={50}
                containerClassName="avatar-skeleton"
              />
              <Skeleton width={70} />
            </Col>
          </Row>
        : <img src={differImg} className="diet-img-100 mb-5" /> }
        <h4 className="mt-0 mb-3 diet-section-title">{dietLoading ? <Skeleton height={26} width="70%" /> : 'Select a plan to learn more'}</h4>
        
        { dietLoading ? <Skeleton count={3} height={100} className="mb-4" /> :
          state.dietPlans.filter(fob => fob.dietPlanType !== 'one_month_smart_diet_plan').map(dietObj => (
            <Link key={dietObj.dietPlanType} to={dietObj.dietPlanType} className="text-decoration-none">
              <DietPlanCard 
                key={dietObj.dietPlanType}
                dietPlan={dietObj} 
                isClickable={true}
                specialLabel={true}
              />
            </Link>
          ))
        }
      </Container>
      }
    </div>
  );
}

export default Diet;